import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export const PaymentCancelPage = () => (
  <main
    data-testid="payment-cancel"
    className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-6 py-20 text-center"
  >
    <XCircle className="h-14 w-14 text-[var(--accent)]" strokeWidth={1.3} />
    <p className="mt-6 text-xs uppercase tracking-[0.35em] text-[var(--accent)]">Nicio grijă</p>
    <h1 className="mt-3 font-serif text-4xl font-light leading-tight text-[#F7F1E8]">
      Plata a fost anulată.
    </h1>
    <p className="mt-3 text-sm text-[#F7F1E8]/78">
      Nu ți s-a retras niciun ban. Poți încerca din nou oricând.
    </p>
    <div className="mt-8 flex flex-wrap justify-center gap-3">
      <Link
        to="/sponsorizeaza"
        data-testid="cancel-retry-btn"
        className="rounded-full bg-[var(--accent)] px-6 py-3 text-xs uppercase tracking-[0.2em] text-white"
      >
        Înapoi la Cumpără-mi o cafea
      </Link>
      <Link
        to="/"
        className="rounded-full border border-[color-mix(in_srgb,var(--milk)_20%,transparent)] px-6 py-3 text-xs uppercase tracking-[0.2em] text-[#F7F1E8]/86"
      >
        Înapoi la jurnal
      </Link>
    </div>
  </main>
);

export default PaymentCancelPage;
